import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frTranslation from "./fr";
import nlTranslation from "./nl";

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    fr: frTranslation,
    nl: nlTranslation,
  },
  fallbackLng: "fr",
  debug: true,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },

  react: {
    wait: true,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js